import { css } from '@emotion/react'
import { mTheme } from '../../../style/themes'

const { size, fontSize, borderColor, backgroundColor, fontColor } = mTheme

export const inlineFooter: Style = css({
  display: 'flex',
  flexDirection: 'column',
  color: '#8a8a8a',
  margin: `${size.M} 0`,
  fontSize: fontSize.S,
})

export const inlineFooterLink: Style = css({
  padding: mTheme.size.XS,
  fontSize: fontSize.S,

  width: '100%',
  '&, &:hover, &:visited': {
    color: fontColor.footerText,
  },
})

export const footerLinks: Style = css({
  display: 'flex',
  flexDirection: 'row',
  gap: mTheme.size.XS,
  justifyContent: 'space-around',
  fontSize: fontSize.S,
  color: fontColor.footerText,
  minWidth: '200px',
  whiteSpace: 'nowrap',
  padding: '0px !important',
  [mTheme.breakpoint.belowMedium]: {
    // flexDirection: 'column',
    gap: mTheme.size.XS,
  },
})

export const copyrightNotice: Style = css({
  fontSize: fontSize.S,
  color: fontColor.footerText,
  alignSelf: 'baseline',
  marginLeft: size.XS,
})

export const fixedBottomFooter: Style = css({
  position: 'fixed',
  bottom: 0,
  width: '100%',
  alignItems: 'center',
  padding: `0.25rem ${size.M}`,
  borderTop: `1px solid ${borderColor.tertiary}`,
  backgroundColor: backgroundColor.primary,
})

export const fixedBottomFooterInner: Style = css({
  maxWidth: '370px',
  margin: `0 auto`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
})

export const separator: Style = css({
  borderLeft: `2px solid ${borderColor.tertiary}`,
  width: '1px',
  margin: '0.10rem 0',
})

export const desktopInlineFooter: Style = css({
  maxWidth: '350px',
  margin: `0 auto ${size.S} auto`,
})

export const hideBelowMedium: Style = css({
  [mTheme.breakpoint.belowMedium]: {
    display: 'none',
  },
})
